var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[_vm.css.root] = true, _obj[_vm.css[_vm.currentLabel.theme]] = true, _obj )},[_vm._v(" "+_vm._s(_vm.currentLabel.title))])}
var staticRenderFns = []

export { render, staticRenderFns }